import type { LevelIconName } from "../../icon";
import { useAppTheme } from "../../useAppTheme";
import { FlatChip } from "../FlatChip";
import { LevelIcon } from "../LevelIcon";

export type LevelChipProps = {
	label: string;
	icon?: LevelIconName;
};

export const LevelChip = ({ label, icon }: LevelChipProps) => {
	const theme = useAppTheme();

	return (
		<FlatChip
			label={label}
			backgroundColor={theme.colors.secondaryContainer}
			leading={
				icon ? (
					<LevelIcon
						name={icon}
						size={16}
						color={theme.colors.onSecondaryContainer}
					/>
				) : undefined
			}
		/>
	);
};
